import React from 'react';
import { DashboardContextProvider } from 'Views/Dashboard/DashboardContext';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';
import DashboardContainer from 'Components/ClientApp/CombinedApp/Viewport/Dashboard/Container';
import PageModal from 'Views/Page/Content/Modal/Components/Modal';

const Dashboard = () => {
  useScrollTopOnMount();
  return (
    <DashboardContextProvider>
      <PageModal />
      <DashboardContainer />
    </DashboardContextProvider>
  );
};

export default Dashboard;
